module.exports = __webpack_public_path__ + "img/bgc3.5a68cac4.png";